import * as yup from 'yup';
// import _keys from 'lodash/keys';
// import { TOURNAMENT_TYPE, TOURNAMENT_WINNER_TYPE } from 'commons/models/common';
import { EMPTY_ARRAY, Row, RenderConfig, Column, SelectInput, AssetUploadInput, ASSET_TYPE_NONS3 } from 'commons-ui';

import { ZUPEE_GAMES, ENVIRONMENT } from './constants';

export const validationSchema = yup.object().shape({
	csv: yup.mixed().test('file', 'Csv file is required', (file) => {
		if (file && file instanceof File && file.name.endsWith('.csv')) {
			return true;
		}
		return false;
	}),
	gameName: yup.string().required(),
	environment: yup.string().required()
});

export const validationSchemaForDiff = yup.object().shape({
	csvDiff: yup.mixed().test('file', 'Csv file is required', (file) => {
		if (file && file instanceof File && file.name.endsWith('.csv')) {
			return true;
		}
		return false;
	}),
	gameName: yup.string().required()
});

export const validationSchemaOfList = yup.object().shape({
	gameName: yup.string().required()
});

export const validationSchemaOfTournamentDevStatus = yup.object().shape({
	gameName: yup.string().required()
});

export const FORM_FIELD_KEYS = {
	ENVIRONMENT: 'environment',
	GAME_NAME: 'gameName',
	CSV: 'csv',
	CSVDIFF: 'csvDiff'
};

export const FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.ENVIRONMENT)]),
		new Column([new Row(FORM_FIELD_KEYS.GAME_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.CSV)])
	])
];

export const FORM_LAYOUT_CONFIG_FOR_DIFF = [
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.GAME_NAME)]), new Column([new Row(FORM_FIELD_KEYS.CSVDIFF)])])
];

export const FORM_LAYOUT_CONFIG_FOR_DEV_STATUS = [new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.GAME_NAME)])])];

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.ENVIRONMENT]: new RenderConfig()
		.setName('environment')
		.setLabel('Environment')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: ENVIRONMENT,
			required: true
		}),
	[FORM_FIELD_KEYS.GAME_NAME]: new RenderConfig()
		.setName('gameName')
		.setLabel('Game Name')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: ZUPEE_GAMES,
			required: true
		}),
	[FORM_FIELD_KEYS.CSV]: new RenderConfig()
		.setName('csv')
		.setLabel('CSV')
		.setRenderer(AssetUploadInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true, assetType: ASSET_TYPE_NONS3.CSV })
};

export const FORM_FIELD_CONFIG_FOR_DIFF = {
	[FORM_FIELD_KEYS.GAME_NAME]: new RenderConfig()
		.setName('gameName')
		.setLabel('Game Name')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: ZUPEE_GAMES,
			required: true
		}),
	[FORM_FIELD_KEYS.CSVDIFF]: new RenderConfig()
		.setName('csvDiff')
		.setLabel('CSV')
		.setRenderer(AssetUploadInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true, assetType: ASSET_TYPE_NONS3.CSV })
};

export const FORM_FIELD_CONFIG_FOR_DEV_STATUS = {
	[FORM_FIELD_KEYS.GAME_NAME]: new RenderConfig()
		.setName('gameName')
		.setLabel('Game Name')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: ZUPEE_GAMES,
			required: true
		})
};

export const getFormDefaults = (): any => {
	return {
		isHidden: false,
		userLevelsSupported: [],
		distribution: {}
	};
};
